<template>
 <!-- 币天销毁量 -->
  <div v-loading="cddLoading"   style="width: 100%; min-height: 700px">

    <!-- 公式 -->
   <el-row type="flex" justify="center">
    <p style="font-weight:550;color:rgba(0,0,0,0.6)">CDD = value · lifespan <span style="color:rgba(0,0,0,0.4)">[days] (of all spent outputs )</span> </p>
   </el-row>
    <!-- 公式 -->
    <el-row type="flex" justify="center">
      <section class="formulas">
          <div>Supply-Adjusted CDD =</div>
          <div>
            <span> CDD</span>
            <span> Total Supply</span>
          </div>
      </section>
   </el-row>
   <Dropdown
          :dataSelection="dataSelection"
          :onSelect="handleSelect"
          :realTimeData="realTimeData"
          style="margin: 10px 0px;"
        ></Dropdown>


     <!-- 对数线性显示切换 -->
    <!-- <el-row>
      <el-col>
         <el-button @click="handelLineSwitch"
         style="margin-left:100px;height:35px;border-radius:6px;"
         >{{ $t(`home.switch`)
          }}<span class="according"> {{ $t(switch3) }}</span></el-button
        >
      </el-col>
    </el-row> -->

    
    <el-row>
      <el-col :span="24">      
        <div
          id="cddBox"
          style="width: 100%; min-height: 700px"
        ></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import IndexJs from "../CDD/index"
export default {
  mixins:[IndexJs]
}
</script>

<style>

</style>